// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2A_Wi","legacyBtn":"MutateMid_legacyBtn__3VFSQ"};